import { ChronoUnit, Duration } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { formatDuration } from "../../../utils/dateUtils";
import { CLOCK_ICON } from "../../../utils/svgs_new";
import { AppListItem } from "../../Generic/AppList";

interface Props {
  durationMinutes: number;
}

const AvailableTaskDurationMinutes = (props: Props) => {
  return (
    <AppListItem
      leading={CLOCK_ICON}
      title={translate(STRINGS.DURATION)}
      trailing={formatDuration(Duration.of(props.durationMinutes, ChronoUnit.MINUTES))}
    />
  );
};

export default AvailableTaskDurationMinutes;
